import React, { useContext, useEffect } from "react";

import { Grid } from "@material-ui/core";

import { TitleTable } from "../../../components/basic/TitleTable";
import Btn from "../../../components/buttons/Btn";
import { GridStyled, LabelStyled } from "../../../styles/GlobalStyle";
import SelectCustom from "../../../components/basic/SelectCustom";
import { getPromocodes } from "../../../repositories/v1/promocode";
import { GlobalVariables } from "../../../global";
import { CustomerContext } from "../contexts/CustomerContext";
import usePromocodeController from "../controllers/PromocodeController";
import { getSellers } from "../../../repositories/seller.repository";

export default function FormPromocode() {
  const {
    documentType,
    cnpj,
    birthDate,
    listSellers,
    setListSellers,
    promocode,
    setPromocode,
    consultantCompany,
    setConsultantCompany,
    consultantUser,
    setConsultantUser,
    franchisedCompany,
    setFranchisedCompany,
    franchisedUser,
    setFranchisedUser,
    accountantCompany,
    setAccountantCompany,
    accountantUser,
    setAccountantUser,
    entityCompany,
    setEntityCompany,
    entityUser,
    setEntityUser,
    loadings,
    setLoadings,
    promoters,
    errors,
  } = useContext(CustomerContext);
  const { handleSavePromocode } = usePromocodeController();

  useEffect(() => {
    const documentsLength = {
      cnpj: 14,
      cpf: 11,
    };
    if (
      !cnpj ||
      cnpj.replace(/[^0-9]+/g, "").length !== documentsLength[documentType]
    )
      return;

    (async () => {
      try {
        setLoadings((current) => ({ ...current, screen: true }));

        const { data: promocode } = await getPromocodes(
          `?ClienteCNPJ=${cnpj.replace(/[^0-9]+/g, "")}`
        );

        if (typeof promocode?.data?.[0] === "object") {
          setPromocode(promocode?.data?.[0]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadings((current) => ({ ...current, screen: false }));
      }
    })();
  }, [cnpj, documentType, setLoadings, setPromocode]);

  useEffect(() => {
    (async () => {
      try {
        setLoadings((current) => ({ ...current, users: true }));

        const { data: users } = await getSellers();

        if (Array.isArray(users?.data)) {
          setListSellers(users.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadings((current) => ({ ...current, users: false }));
      }
    })();
  }, [setLoadings, setListSellers]);

  useEffect(() => {
    if (!listSellers.length || !Object.keys(promocode).length) return;

    setConsultantUser(
      listSellers.find(
        (seller) => seller.Id === promocode.IdUsuarioConsultor
      ) || null
    );

    setFranchisedUser(
      listSellers.find((seller) => seller.Id === promocode.IdUsuarioFranquia) ||
        null
    );

    setAccountantUser(
      listSellers.find((seller) => seller.Id === promocode.IdUsuarioContador) ||
        null
    );

    setEntityUser(
      listSellers.find((seller) => seller.Id === promocode.IdUsuarioEntidade) ||
        null
    );
  }, [
    listSellers,
    promocode,
    setConsultantUser,
    setFranchisedUser,
    setAccountantUser,
    setEntityUser,
  ]);

  useEffect(() => {
    if (!promoters.length || !Object.keys(promocode).length) return;

    setConsultantCompany(
      promoters.find(
        (promoter) =>
          promoter.CNPJ === promocode.IdPromotorConsultor &&
          promoter.IdTipoPromotor ===
            parseInt(GlobalVariables.TIPO_PROMOTOR_CONSULTOR)
      ) || null
    );

    setFranchisedCompany(
      promoters.find(
        (promoter) =>
          promoter.CNPJ === promocode.IdPromotorFranquia &&
          promoter.IdTipoPromotor ===
            parseInt(GlobalVariables.TIPO_PROMOTOR_FRANQUIA)
      ) || null
    );

    setAccountantCompany(
      promoters.find(
        (promoter) =>
          promoter.CNPJ === promocode.IdPromotorContador &&
          promoter.IdTipoPromotor ===
            parseInt(GlobalVariables.TIPO_PROMOTOR_CONTADOR)
      ) || null
    );

    setEntityCompany(
      promoters.find(
        (promoter) =>
          promoter.CNPJ === promocode.IdPromotorEntidade &&
          promoter.IdTipoPromotor ===
            parseInt(GlobalVariables.TIPO_PROMOTOR_ENTIDADE)
      ) || null
    );
  }, [
    promoters,
    promocode,
    setConsultantCompany,
    setFranchisedCompany,
    setAccountantCompany,
    setEntityCompany,
  ]);

  return (
    <>
      <Grid item xs={12}>
        <TitleTable title="Promocode" />
      </Grid>

      <Grid item container spacing={2} alignItems="center">
        <Grid item sm={2} xs={12}>
          <LabelStyled>Consultor</LabelStyled>
        </Grid>
        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.promoters}
            label="Promotor"
            keyObject="Fantasia"
            value={consultantCompany}
            setValue={(e) => {
              setConsultantCompany(e);
              setConsultantUser(null);
            }}
            optionsList={promoters.filter(
              (p) =>
                p.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_CONSULTOR)
            )}
          />
        </Grid>

        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.users}
            label="Vendedor"
            keyObject="Nome"
            value={consultantUser}
            setValue={setConsultantUser}
            optionsList={
              consultantCompany
                ? listSellers.filter(
                    (seller) => seller.CnpjPromotor === consultantCompany.CNPJ
                  )
                : []
            }
          />
        </Grid>

        <Grid item sm={2} xs={12}>
          <LabelStyled>Franquia</LabelStyled>
        </Grid>
        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.promoters}
            error={errors.franchiseField}
            label="Promotor"
            keyObject="Fantasia"
            value={franchisedCompany}
            setValue={(e) => {
              setFranchisedCompany(e);
              setFranchisedUser(null);
            }}
            optionsList={promoters.filter(
              (p) =>
                p.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_FRANQUIA)
            )}
          />
        </Grid>

        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.users}
            label="Vendedor"
            keyObject="Nome"
            value={franchisedUser}
            setValue={setFranchisedUser}
            optionsList={
              franchisedCompany
                ? listSellers.filter(
                    (seller) => seller.CnpjPromotor === franchisedCompany.CNPJ
                  )
                : []
            }
          />
        </Grid>

        <Grid item sm={2} xs={12}>
          <LabelStyled>Contador</LabelStyled>
        </Grid>
        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.promoters}
            label="Promotor"
            keyObject="Fantasia"
            value={accountantCompany}
            setValue={(e) => {
              setAccountantCompany(e);
              setAccountantUser(null);
            }}
            optionsList={promoters.filter(
              (p) =>
                p.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_CONTADOR)
            )}
          />
        </Grid>

        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.users}
            label="Vendedor"
            keyObject="Nome"
            value={accountantUser}
            setValue={setAccountantUser}
            optionsList={
              accountantCompany
                ? listSellers.filter(
                    (seller) => seller.CnpjPromotor === accountantCompany.CNPJ
                  )
                : []
            }
          />
        </Grid>

        <Grid item sm={2} xs={12}>
          <LabelStyled>Entidade</LabelStyled>
        </Grid>
        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.promoters}
            label="Promotor"
            keyObject="Fantasia"
            value={entityCompany}
            setValue={(e) => {
              setEntityCompany(e);
              setEntityUser(null);
            }}
            optionsList={promoters.filter(
              (p) =>
                p.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_ENTIDADE)
            )}
          />
        </Grid>

        <Grid item sm={5} xs={6}>
          <SelectCustom
            loading={!!loadings.users}
            label="Vendedor"
            keyObject="Nome"
            value={entityUser}
            setValue={setEntityUser}
            optionsList={
              entityCompany
                ? listSellers.filter(
                    (seller) => seller.CnpjPromotor === entityCompany.CNPJ
                  )
                : []
            }
          />
        </Grid>

        <GridStyled margin="15px 0 0 0" item container justify="center">
          <Btn label="Salvar Promocode" onClick={handleSavePromocode} />
        </GridStyled>
      </Grid>
    </>
  );
}
